import usePlans from "@/hooks/usePlans";
import { useMemo } from "react";
import findPlanForType from "../utils/findPlanForType";
import { TProxyTabType } from "@/components/newcustomize/utils/makeProxyTabType";
import { PlanType } from "@/types/PlanTypes";

/**
 * Returns only the active plans
 */
export default function useNavPlans() {
  const { data: plans, isLoading: isLoadingPlans } = usePlans();

  const planByType = useMemo(() => {
    const freePlan = plans?.results?.find(
      (plan) => plan.proxy_type === "free" && plan.status === "active"
    );
    return {
      datacenter: !!freePlan
        ? undefined
        : findPlanForType(plans?.results || [], "datacenter", true),

      staticResidential: findPlanForType(
        plans?.results || [],
        "staticResidential",
        true
      ),
      residential: findPlanForType(plans?.results || [], "residential", true),
      verified: findPlanForType(plans?.results || [], "verified", true),
      free: freePlan,
    } as Record<TProxyTabType | "free", PlanType | undefined>;
  }, [plans]);
  return { planByType, isLoadingPlans };
}
